import { createContext } from 'react'

export type BulkSelectionContextValue = {
  selectedIds: Set<string>
  toggle: (id: string) => void
  clear: () => void
  // Replaces the entire selection with exactly `ids` — used for "select all"
  // over whatever's currently visible, not an additive union with what was
  // already selected.
  selectAll: (ids: string[]) => void
  count: number
}

export const BulkSelectionContext =
  createContext<BulkSelectionContextValue | null>(null)
